var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#878787",
    fillRule: "evenodd",
    d: "M6 7.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm0-4a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zm0 11c-.832.004-5-6.41-5-8.5a5 5 0 0 1 10 0c0 2.062-4.182 8.504-5 8.5zM6 0a6 6 0 0 0-6 6c0 2.509 5.002 10.005 6 10 .982.005 6-7.525 6-10a6 6 0 0 0-6-6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.8e856705.svg";
export { ForwardRef as ReactComponent };